<template>
    <div class="register-container">
      <div class="register-box">
        <h2>Create an Account</h2>
        <form @submit.prevent="register">
          <input v-model="user.firstName" placeholder="First Name" class="input-field" required />
          <input v-model="user.lastName" placeholder="Last Name" class="input-field" required />
          <input v-model="user.username" placeholder="Username" class="input-field" required />
          <input v-model="user.email" type="email" placeholder="Email" class="input-field" required />
          <input v-model="user.phoneNumber" placeholder="Phone Number" class="input-field" required />
          <input v-model="user.password" type="password" placeholder="Password" class="input-field" required />
          <button type="submit" class="register-button">Register</button>
        </form>
        <p v-if="error" class="error-message">{{ error }}</p>
        <p v-if="success" class="success-message">Registration successful! <router-link to="/login">Login</router-link></p>
      </div>
    </div>
  </template>
  
  <script>
  import { AuthApi } from '../api';
  
  export default {
    data() {
      return {
        user: {
          firstName: "",
          lastName: "",
          username: "",
          email: "",
          phoneNumber: "",
          password: "",
        },
        error: "",
        success: false,
      };
    },
    methods: {
      async register() {
        try {
          await AuthApi.register(this.user);
          this.success = true; // Show success message
          this.error = "";
        } catch (error) {
          console.error("Registration Error:", error);
          this.error = "Registration failed. Please check your details.";
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .register-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f4f4f4;
  }
  
  .register-box {
    background: white;
    padding: 2rem;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 350px;
  }
  
  .input-field {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .register-button {
    width: 100%;
    padding: 10px;
    background-color: #28a745;
    border: none;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
  }
  
  .register-button:hover {
    background-color: #218838;
  }
  
  .error-message {
    color: red;
    margin-top: 10px;
  }
  
  .success-message {
    color: green;
    margin-top: 10px;
  }
  </style>
  